import clsx from 'clsx'

import { LuGitPullRequestArrow, LuInfo } from 'react-icons/lu'

import { Button } from '@/lib/core/components/Button'
import { FeatureModal } from '@/lib/core/components/Modal'
import { Tooltip } from '@/lib/core/components/Tooltip'

import messages from '@/lib/features/SmartShares/components/ShareAssetModal/ShareAssetModal.messages'

import { FeatureTypes } from '@/lib/utils/features'

import styles from './SelectShareClassModal.module.css'
import { SelectShareClassModalProps } from './SelectShareClassModal.types'
import { shareClassOptions } from './SelectShareClassModal.utils'
import { useSelectShareClassModal } from './useSelectShareClassModal'

export const SelectShareClassModal = ({ isActive, onClose }: SelectShareClassModalProps) => {
  const { selectedShareClass, selectShareClass, confirmSelection, isNextDisabled } =
    useSelectShareClassModal()

  return (
    <FeatureModal
      isActive={isActive}
      feature={FeatureTypes.SHARES}
      title={messages.selectShareClassModalTitle.defaultMessage}
      titleIcon={<LuGitPullRequestArrow size={48} />}
      subtitle={messages.selectShareClassSubtitle.defaultMessage}
      onClose={() => onClose?.(false)}
    >
      <div className={styles.container} data-testid="select-share-class-step">
        <div className={styles.label}>
          {messages.selectShareClassLabel.defaultMessage}
          <Tooltip
            maxWidth={320}
            placement="bottom"
            tooltipContent={
              <div className={styles.tooltip}>
                <p>{messages.selectShareClassSmartShareInfo.defaultMessage}</p>
                <p>{messages.selectShareClassDelegateInfo.defaultMessage}</p>
              </div>
            }
          >
            <button
              type="button"
              className={styles.infoButton}
              aria-label={messages.selectShareClassInfoLabel.defaultMessage}
              data-testid="share-class-info"
            >
              <LuInfo size={18} />
            </button>
          </Tooltip>
        </div>

        <div
          className={styles.cards}
          role="radiogroup"
          aria-label={messages.selectShareClassLabel.defaultMessage}
        >
          {shareClassOptions.map(({ shareClass, title, description, Icon, testId }) => {
            const isSelected = selectedShareClass === shareClass

            return (
              <button
                key={shareClass}
                type="button"
                role="radio"
                aria-checked={isSelected}
                className={clsx(styles.card, isSelected && styles.cardSelected)}
                data-testid={testId}
                onClick={() => selectShareClass(shareClass)}
              >
                <span className={styles.cardTitle}>{title}</span>
                <span className={styles.cardIcon}>
                  <Icon size={72} strokeWidth={1.25} />
                </span>
                <span className={styles.cardDescription}>{description}</span>
              </button>
            )
          })}
        </div>

        <div className={styles.actions}>
          <Button
            type="button"
            variant="secondary"
            $fitToContent
            size="large"
            minWidth
            disabled={isNextDisabled}
            onClick={confirmSelection}
            data-testid="share-class-next"
          >
            {messages.sendButton.defaultMessage}
          </Button>
        </div>
      </div>
    </FeatureModal>
  )
}
